module.exports = require("./daterangepicker.js");
require("./daterangepicker.css");


//////////////////
// WEBPACK FOOTER
// bootstrap-daterangepicker (bower component)
// module id = 1252
// module chunks = 1